import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'taxIdHiddenMask'
})
export class TaxIdHiddenMaskPipe implements PipeTransform {

  transform(value?: string): unknown {
    if (!value) return '';

    if (value.includes('*')) {
      return value;
    }

    let formattedValue = '';
    if (value.length == 11) {
      const visiblePart1 = value.substring(3, 6);
      const visiblePart2 = value.substring(6, 9);
      formattedValue = `***.${visiblePart1}.${visiblePart2}-**`;
    } else if (value.length == 14) {
      const visiblePart1 = value.substring(3, 4);
      const visiblePart2 = value.substring(4, 5);
      const visiblePart3 = value.substring(5, 8);
      const visiblePart4 = value.substring(8, 12);
      formattedValue = `**.*${visiblePart1}${visiblePart2}.${visiblePart3}/${visiblePart4}-**`;
    }
    return formattedValue;
  }
}
